import cn from 'classnames';
import React from 'react';
import { useStratsContext } from '@/finsight/application/Strats/StratsContext';
import styles from '@/finsight/ui/components/strats/FiltersTable/filtersTable.scss';
import stratsStyles from '@/finsight/ui/components/strats/strats.scss';
import Spinner from '@dealroadshow/uikit/core/components/Loader/Spinner';
import { getSummaryValue } from '@/finsight/ui/components/strats/helpers';

const renderRows = (item, i) => (
  <div
    key={ i }
    className={ styles.row }
    data-test={ `row[${ i }]` }
  >
    <div className={ cn(styles.col, styles.label) }>
      { item.label }
    </div>
    <div className={ cn(styles.col, styles.value) }>
      { getSummaryValue(item.label, item.value) }
    </div>
  </div>
);

const FiltersTable = () => {
  const {
    summaryFilters,
    summaryFiltersFetching,
    rangeExcludedIds,
    onResetAllFilters,
  } = useStratsContext();
  const isFetching = summaryFiltersFetching || !summaryFilters?.length;

  return (
    <div className={ styles.filtersCol }>
      <div className={ styles.card } data-test="stratMakerFilterTable">
        <div className={ stratsStyles.panelHeader }>
          <h3 data-test="filterTableTitle">Filters</h3>
          <Spinner
            isVisible={ isFetching }
            className={ stratsStyles.panelSpinner }
          />
        </div>
        { !!summaryFilters?.length && (
          <>
            <div className={ styles.tableContainer }>
              { summaryFilters.map(renderRows) }
            </div>
            <button
              type="button"
              className={ styles.resetButton }
              disabled={ !rangeExcludedIds.length || isFetching }
              onClick={ onResetAllFilters }
              data-test="resetAllFilterButton"
            >
              Reset All Filters
            </button>
          </>
        ) }
      </div>
    </div>
  );
};

export default FiltersTable;
